export const RTE_SETTINGS = {
	modules: {
		toolbar: [
			[{ header: [1, 2, 3, 4, false] }],
			['bold', 'italic', 'underline', 'strike'],
			[{ align: [] }],
			[{ list: 'ordered' }, { list: 'bullet' }],
			['link'],
			['clean']
		]
	},
	formats: ['header', 'bold', 'italic', 'underline', 'strike', 'list', 'link', 'align'],
	theme: 'snow'
};
